export const  reviewText = {
residence: "Você precisa enviar uma foto de um dos seguintes documentos contendo seu nome completo: Conta de consumo; Contrato ou recibo de aluguel; Nota fiscal; Boletos; Declaração recente de Imposto de Renda ou outro tipo de documento que comprove a residência informada anteriormente.",
document: "A foto não pode estar tremida e as informações devem dar leitura."
}